import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
//

const useResizeSnaDiv = ({
  sidebarOpen,
  setSnaHeight,
  setSnaWidth,
  defaultWidth,
  defaultHeight,
  snaDivId,
}) => {
  const [localWidth, setLocalWidth] = useState(0);
  const [localHeight, setLocalHeight] = useState(0);
  const [localSidebarOpen, setLocalSidebarOpen] = useState(sidebarOpen);

  // when sidebar open
  const setDefaultWidthHeight = () => {
    setSnaWidth(defaultWidth);
    setLocalWidth(defaultWidth);
    //
    setSnaHeight(defaultHeight);
    setLocalHeight(defaultHeight);
  };

  // when sidebar closed
  const setDefaultWidthHeightClose = (contentBoxSize) => {
    // inlineSize: horizontal dimension, or width
    // blockSize:  vertical dimension, or height
    // not fullscreen!
    setSnaWidth(contentBoxSize.inlineSize - 60);
    setLocalWidth(contentBoxSize.inlineSize);
    //
    // setSnaHeight(contentBoxSize.blockSize);
    setSnaHeight(contentBoxSize.blockSize);
    setLocalHeight(contentBoxSize.blockSize);
  };

  useEffect(() => {
    if (sidebarOpen !== localSidebarOpen) {
      setLocalSidebarOpen(sidebarOpen);
    }
  }, [sidebarOpen]);

  const updateWidthAndHeight = (ele) => () => {
    // console.log('window.innerWidth', window.innerWidth)
    if (document.fullscreenElement) {
      // it's fullscreen!
      // 變更 sna svg 的長寬
      if (ele.innerWidth) {
        setSnaWidth(ele.innerWidth);
        setLocalWidth(ele.innerWidth);
      }
      if (ele.innerHeight) {
        setSnaHeight(ele.innerHeight);
        setLocalHeight(ele.innerHeight);
      }
    } else {
      // not fullscreen!
      setDefaultWidthHeight();
    }
  };

  // update sna div width and height when window resize
  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight(window));
    return () =>
      window.removeEventListener("resize", updateWidthAndHeight(window));
  });

  useEffect(() => {
    const snaDivResizeHandler = (_sidebarOpen) => (entries) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          // entry object properties:
          // borderBoxSize : [blockSize,inlineSize]
          // contentBoxSize
          // contentRect
          // devicePixelContentBoxSize
          // target
          // Firefox implements `contentBoxSize` as a single content rect, rather than an array
          const contentBoxSize = Array.isArray(entry.contentBoxSize)
            ? entry.contentBoxSize[0]
            : entry.contentBoxSize;

          if (document.fullscreenElement) {
            // it's fullscreen!
            setSnaWidth(contentBoxSize.inlineSize);
            setLocalWidth(contentBoxSize.inlineSize);
            //
            setSnaHeight(contentBoxSize.blockSize);
            setLocalHeight(contentBoxSize.blockSize);
          } else if (_sidebarOpen) {
            // not fullscreen!
            setDefaultWidthHeight();
          } else {
            setDefaultWidthHeightClose(contentBoxSize);
          }
        }
      }
    };
    const snaDivResizeObserver = new ResizeObserver(
      snaDivResizeHandler(localSidebarOpen)
    );
    const targetEle = document.getElementById(snaDivId);
    snaDivResizeObserver.observe(targetEle);
  }, [localSidebarOpen]);

  return { newWidth: localWidth, newHeight: localHeight };
};

useResizeSnaDiv.propTypes = {
  sidebarOpen: PropTypes.bool,
  setSnaWidth: PropTypes.func,
  setSnaHeight: PropTypes.func,
  defaultWidth: PropTypes.number,
  defaultHeight: PropTypes.number,
  snaDivId: PropTypes.string,
};

useResizeSnaDiv.defaultProps = {
  sidebarOpen: true,
  setSnaWidth: () => null,
  setSnaHeight: () => null,
  defaultWidth: 0,
  defaultHeight: 0,
  snaDivId: "",
};

export default useResizeSnaDiv;
